import { Component, OnInit, OnChanges, Input, SimpleChanges } from '@angular/core';

import { MatterService } from '../../../services/matters/matter.service';

@Component({
  selector: 'app-matter-associations',
  templateUrl: './matter-associations.component.html',
  styleUrls: ['./matter-associations.component.css'],
})
export class MatterAssociationsComponent implements OnInit, OnChanges {
  @Input() matter_id: number;

  matterAssociations: any = {
    ancestors: [],
    siblings: [],
    descendants: [],
  };

  matter_associations_loading: boolean = true;

  constructor(private matterService: MatterService) {}

  // Component lifecycle events
  ngOnInit() {
    this.loadMatterAssociations();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.matter_id && changes.matter_id.currentValue) this.loadMatterAssociations();
  }

  // Component methods
  loadMatterAssociations() {
    this.matterService.getMatterAssociations(this.matter_id).then((response_json) => {
      this.matterAssociations = response_json;
      this.matter_associations_loading = false;
    });
  }
}
